export class FormValidationError extends Error {
  constructor(invalidFields = {}) {
    super('Form is invalid');
    this.invalidFields = invalidFields;
  }
}

export class UnknownError extends Error {}
